import { z } from "zod/v4-mini";

import { publicApiDataSource } from "@/io/datasource/ApiDatasource.ts";
import { BaseApiDatasourceSpec } from "@/io/datasource/BaseApiDatasource.ts";
import { localStorageDataSource, LocalStorageDataSourceSpec } from "@/io/datasource/LocalStorageDatasource.ts";
import { RefreshedTokens, refreshedTokensSchema, TokenPair, tokenPairSchema } from "@/models/AuthModel";
import { cz } from "@/utils/zodUtils";

export type LoginIdentifier = { phone: string } | { email: string };

export class AuthRepository {
  constructor(
    private readonly localStorageDatasource: LocalStorageDataSourceSpec = localStorageDataSource,
    private readonly publicDatasource: BaseApiDatasourceSpec = publicApiDataSource,
  ) {}

  /*******************************/
  /************* API *************/
  /*******************************/

  requestLoginCode = (identifier: LoginIdentifier): Promise<undefined> =>
    this.publicDatasource.post("/auth/login-code/request/", cz.ignore(), {
      ...identifier,
      user_type: "patient",
    });

  verifyLoginCode = (identifier: LoginIdentifier, code: string): Promise<TokenPair> =>
    this.publicDatasource.post("/auth/login-code/verify/", tokenPairSchema, {
      ...identifier,
      code,
      user_type: "patient",
    });

  refreshTokens = (refresh: string): Promise<RefreshedTokens> =>
    this.publicDatasource.post("/auth/token/refresh/", refreshedTokensSchema, {
      refresh,
    });

  revokeRefreshToken = (refresh: string): Promise<undefined> =>
    this.publicDatasource.post("/auth/logout/", cz.ignore(), {
      refresh,
    });

  /*******************************/
  /*********** STORAGE ***********/
  /*******************************/

  getRefreshToken = () => this.localStorageDatasource.retrieve("unauthenticated", "refreshToken", z.string());

  setRefreshToken = (token: string) => this.localStorageDatasource.store("unauthenticated", "refreshToken", token);

  deleteRefreshToken = async (): Promise<undefined> => {
    this.localStorageDatasource.remove("unauthenticated", "refreshToken");
  };
}
